import React, {ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo} from "react";
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {Row, Col, Input, Select, Table, Typography, Tooltip, Popover, Button, Modal, Radio, notification} from "antd";
import {http_get, http_request, response_type, destroy_worker} from "../../worker/http-func";
import {worker_fetch} from '../../worker/worker-fetch';
import {workspaces_type_item, WorkspaceContext} from "../../contexts/workspaces";
import {NamespaceContext, namespaces_type_item} from "../../contexts/namespaces";
import {select} from "../../components/table-list/table-list";
import {ClusterSelectedContext} from "../../contexts/cluster-selected";
import {WorkSpaceSelectedContext} from "../../contexts/workspace-selected";
import {NameSpaceSelectedContext} from "../../contexts/namespace-selected";
import {item} from "../../contexts/items";
import {RolesContext, role_type} from "../../contexts/roles";
import {workspacename} from "../global/global";
import './applications.less';
import {UserInfoContext, IUserInfoType} from "../../contexts/user-info";
import {clusters_type_item, ClusterContext} from "../../contexts/clusters";
import {DatacenternameContext} from "../../contexts/datacenter-name";
import {ColumnsType} from "antd/lib/table";
import Icon, {
    SearchOutlined,
    CloudUploadOutlined,
    PlayCircleFilled,
    LinkOutlined,
    LoadingOutlined,
    QuestionCircleOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import {modal_data_type} from './applications-detail';
import {loading_alert_before, loading_alert_after, alert, close_loading, get_domain} from './common-file/service';
import { terminal } from "../../img";
import { TableListModalContext } from "../../components/table-list/table-list";
import TableListModal from "../../components/table-list-modal/table-list-modal";
import { table_list_modal_type, TableListModalTypeContext } from "../../contexts/table_list_modal";
// import DropdownMenuSubscription from "../../components/dropdown-menu-subscription/dropdown-menu-subscription";
import { cry } from "../../img";
import { UserSubscriptionsContext, user_subscription } from "../../contexts/user-subscriptions";
import { TypeNameContext } from "../../contexts/type_name";
import Cookies from "universal-cookie";

close_loading();

const {Option} = Select;

const cookies = new Cookies();

// interface app_response {
//     data?: app_item[];
//     error?: string | null;
//     path?: string;
//     status?: number;
//     timestamp?: string;
//     totalCount?: string | number;
//     code?: number,
//     index?: number,
//     kind?: string
// }

export interface app_item {
    serviceInstanceId: string,
    serviceInstanceName: string,
    servicePlanName: string,
    serviceName: string,
    appServiceInfo: {
        chartVersion: string,
    },
    lifecycleStatus: "Active",
    icon: string,
    uuid: string,
    servicePackageName: string,
    instanceList: object[],
    externalPortalUrl: any

}

export const prevent = (event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>): void => {
    event.preventDefault();
    event.stopPropagation();
};

export const UpdateSvg = ()=>(
    <svg viewBox="0 0 1024 1024" width="1em" height="1em">
        <path
            d="M531.2 800V236.8l134.4 121.6L736 288 480 57.6 224 288l70.4 70.4 134.4-121.6v563.2h102.4zM224 896v96h512V896H224z"
            fill="currentColor"
            p-id="6207"
        />
    </svg>
);

export const StopSvg = ()=>(
    <svg viewBox="0 0 1024 1024" p-id="5247" width="1em" height="1em" fill="currentColor">
        <path
            d="M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 928c-229.76 0-416-186.24-416-416s186.24-416 416-416 416 186.24 416 416-186.24 416-416 416zM320 320l384 0 0 384-384 0z"
            p-id="5248"
        />
    </svg>
);


const UpdateIcon = (props: any) => <Icon component={UpdateSvg} {...props} />;
const StopIcon = (props: any) => <Icon component={StopSvg} {...props} />;

const return_color = (status: string) => {
    switch (status.toLowerCase()) {
        case 'running':
            return 'btn-success';
        case 'warning':
            return 'btn-warning';
        case 'stopped':
            return 'btn-blue';
        case 'unknown':
            return 'btn-default';
        case 'error':
            return 'btn-danger';
        default:
            return 'btn-danger';
    }
};

const Applications: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
        [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(NameSpaceSelectedContext),
        set_type_name: React.Dispatch<React.SetStateAction<string | undefined>> = useContext(TypeNameContext)[1],
        [modal_data, set_modal_data]: [modal_data_type, React.Dispatch<React.SetStateAction<modal_data_type>>] = useState({}),
        [modal_loading, set_modal_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(() => false),
        [datasource, set_datasource]: [app_item[], React.Dispatch<React.SetStateAction<app_item[]>>] = useState<app_item[]>([]),
        [apps_total, set_apps_total]: [app_item[], React.Dispatch<React.SetStateAction<app_item[]>>] = useState<app_item[]>([]),
        [load_apps_total, set_load_apps_total]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [load_apps_total_version, set_load_apps_total_version]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [item_selected, set_item_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
        [list_status, set_list_status]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
        [list_access_url, set_list_access_url]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
        [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useContext(UserInfoContext),
        [user_subscriptions, set_user_subscriptions]: [
            user_subscription[] | undefined,
            React.Dispatch<React.SetStateAction<user_subscription[] | undefined>>
        ] = useContext(UserSubscriptionsContext),
        [select_menu, set_select_menu]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p/>),
        [table_ele, set_table_ele]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p/>),
        [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        [location_total, set_location_total]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(0),
        roles: role_type[] = useContext(RolesContext)[0],
        [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(NamespaceContext),
        [refresh_status, set_refresh_status]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(null),
        [package_list, set_package_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(null),
        [load_package_list, set_load_package_list]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
        [is_first, set_is_first]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
        [package_selected, set_package_selected]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(sessionStorage.getItem('package_selected') || 'all'),
        [table_pagination, set_table_pagination]: [any, React.Dispatch<React.SetStateAction<any>>] = useState({
            current: 1,
            defaultPageSize: 10,
            pageSize: 10
        }),
        [table_sorter_datasource, set_table_sorter_datasource]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
        set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        [version_list, set_version_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null),
        [update_version, set_update_version]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(''),
        [update_type, set_update_type]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(1),
        [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
            TableListModalTypeContext
          ),
        [subscription_noapp_modal_visible, set_subscription_noapp_modal_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        path: string = props.history.location.pathname.substring(1),
        {intl, history} = props,
        {formatMessage} = useMemo(() => props.intl, [props]);

    useEffect(() => () => {
        destroy_worker()
    }, []);

    useEffect(() => {
        if (user_info?.subscription_id && user_info?.ssoSubscriptions?.length > 0 ) {
            set_subscription_noapp_modal_visible(false)
        } else if (user_info && user_info.ssoRole !== "globalAdmin" && user_info?.ssoSubscriptions?.length <= 0) {
            setTimeout(() => {
                set_subscription_noapp_modal_visible(true)
            }, 3000);
        }
        // eslint-disable-next-line
    }, [user_info?.subscription_id, user_info.ssoRole, user_info?.ssoSubscriptions]);

    useEffect(()=>{
        if (is_first){
            set_cluster_selected({name: 'all'});
            set_workspace_selected({name: 'all'});
            set_namespace_selected({name: 'all'});
            sessionStorage.setItem("cluster", 'all');
            set_is_first(false);
        }
        // eslint-disable-next-line
    }, [cluster_selected]);

    useEffect((): void => {
        if (clusters) {
            // const data: string = sessionStorage.getItem("cluster") || "all",
            //     selected = Array.isArray(clusters) && clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
            // if (selected) set_cluster_selected(selected.metadata);
            // else {
                // const {metadata}: clusters_type_item = clusters[0];
                // set_cluster_selected(metadata);
                set_cluster_selected({name: 'all'});
                set_workspace_selected({name: 'all'});
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("cluster", 'all');
            // }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clusters, set_cluster_selected]);

    useEffect((): void => {
        // const pathname = props.history.location.pathname,
        //   push = () => { if (pathname.includes('/workspace-info/') || pathname.includes('/namespace-info/')) props.history.push('/cluster-info/workspaces') };
        if (workspaces && Array.isArray(workspaces)) {
            // const data: string = sessionStorage.getItem("workspace") || "all";
            // const selected = workspaces?.find((workspace: workspaces_type_item) => workspace.metadata && workspace.metadata.name === data);
            // if (selected) set_workspace_selected(selected.metadata);
            // else {
                // const {metadata}: workspaces_type_item = workspaces[0];
                // set_workspace_selected(metadata);
                set_workspace_selected({name: 'all'});
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("workspace", 'all');
            // }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workspaces, set_workspace_selected]);

    useEffect((): void => {
        if (!path.includes("monitor") && namespaces) {
            // const data: string = sessionStorage.getItem("namespace") || "all",
            //     selected = Array.isArray(namespaces) && namespaces.find((namespace: namespaces_type_item) => namespace.metadata?.name === data);
            // if (selected) set_namespace_selected(selected.metadata);
            // else{
                // const {metadata}: namespaces_type_item = namespaces[0];
                // set_namespace_selected(metadata);
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("namespace", 'all');
            // }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_namespace_selected, namespaces, workspace_selected]);

    useEffect((): void => {
        user_info.role !== '' && datacenter_name && http_get('applications_page', ['clusters', set_clusters], user_info.role, user_info.subscription_id, datacenter_name, cluster_selected?.name || '');
        set_workspaces(undefined);
        set_workspace_selected({name: 'all'});
        // sessionStorage.removeItem('workspace');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_workspaces, user_info.role, user_info.subscription_id, set_clusters]);

    useEffect((): void => {
        (async () => {
            if (cluster_selected?.name && cluster_selected.name !== 'all' && datacenter_name && !is_first) {
                loading_alert_before();
                set_workspaces(undefined);
                set_workspace_selected({name: 'all'});
                set_namespaces(undefined);
                set_namespace_selected({name: 'all'});
                // sessionStorage.removeItem('namespace');
                const {name}: item = cluster_selected;
                if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                    const workspacenames: workspacename[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as workspacename[];
                    workspacenames && set_workspaces(workspacenames.map(({name, id}: workspacename) => {
                        return {metadata: {name: id, labels: {name}}} as workspaces_type_item
                    }));
                } else {
                    name && http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true);
                }
                loading_alert_after();
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper, is_first]);

    useEffect((): void => {
        if (user_info.role !== '' && cluster_selected?.name && cluster_selected.name !== 'all' && workspace_selected?.name && workspace_selected.name !== 'all' && datacenter_name && !is_first) {
            const name = workspace_selected.name;
            name && http_request('namespaces', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspace/${name}/namespaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name, undefined, undefined, undefined, undefined, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workspace_selected && workspace_selected.name, user_info.role, user_info.subscription_id, set_namespaces, is_first]);

    useEffect(()=>{
        !load_apps_total && set_load_apps_total(true);
        !load_package_list && set_load_package_list(true);
        // eslint-disable-next-line
    }, [user_info.subscription_id]);

    useEffect((): void => {
        (async () => {
            const name = namespace_selected?.name,
                cname = cluster_selected?.name,
                wkname = workspace_selected?.name,
                subscription_vaild = (user_info?.ssoSubscriptions && user_info?.ssoSubscriptions?.length >0 && user_info?.ssoSubscriptions.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === user_info.subscription_id)) || user_info.ssoRole === "globalAdmin";
            if (user_info.subscription_id && subscription_vaild && cname && name && wkname && datacenter_name) {
                if(load_apps_total){
                    loading_alert_before();
                    set_load_apps_total(false);
                    const {data}: any = await worker_fetch({
                            url:`/appBuy/serviceInstances?subscriptionId=${user_info.subscription_id}&datacenterCode=${datacenter_name}&clusterName=${(cname !== 'all') ? cname : ''}&workspaceId=${(wkname !== 'all') ? wkname : ''}&namespaceName=${(name !== 'all') ? name : ''}&onlyActived=true&pageSize=9999999`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    });
                    set_location_total(Number(data?.totalCount || 0));
                    set_apps_total(data?.data || []);
                    set_load_apps_total_version(true);
                    loading_alert_after();
                }
            } else {
                set_apps_total([])
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_location_total, user_info.subscription_id, user_info?.ssoSubscriptions, datacenter_name, cluster_selected?.name, workspace_selected?.name, namespace_selected?.name, load_apps_total, set_load_apps_total]);

    useEffect(()=>{
        const name = namespace_selected?.name,
            cname = cluster_selected?.name,
            wkname = workspace_selected?.name,
            subscription_vaild = (user_info?.ssoSubscriptions && user_info?.ssoSubscriptions?.length >0 && user_info?.ssoSubscriptions.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === user_info.subscription_id)) || user_info.ssoRole === "globalAdmin"
        if(user_info.subscription_id && subscription_vaild && datacenter_name && name && cname && wkname){
            set_package_selected('all');
            set_load_package_list(false);
            (async ()=>{
                loading_alert_before();
                const {data}: any = await worker_fetch({
                    url: `/appBuy/servicePackages?subscriptionId=${user_info.subscription_id}&datacenterCode=${datacenter_name}&clusterName=${cname === 'all'? '': cname}&workspaceId=${wkname === 'all'? '': wkname}&namespaceName=${name === 'all'? '': name}&onlyActived=true`,
                    method: 0,
                    props: {formatMessage, history},
                    datacenter_name
                }) || {};
                data?.data && set_package_list(Array.from(new Set(data.data)));
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [user_info.subscription_id, user_info?.ssoSubscriptions, set_package_list, datacenter_name, load_package_list, cluster_selected?.name, workspace_selected?.name, namespace_selected?.name, path]);

    useEffect(()=>{
        if(table_sorter_datasource.length>0 && load_apps_total_version){
            set_load_apps_total_version(false);
            const {current, pageSize} = table_pagination,
                start_num: number = Number((current-1)*10 || 0),
                end_num: number = Number(start_num + pageSize),
                new_apps_total: any = [...(table_sorter_datasource.slice(start_num, end_num))];
            let id_list: string[] = [],
                id_key: number[] = [],
                new_status_list: any = list_status,
                new_access_list: any = list_access_url;
            new_apps_total?.map(async(item: any)=>{
                const {data}: any = await worker_fetch({
                    url: `/appBuy/serviceInstances/${item?.serviceInstanceId}/instances`,
                    method: 0,
                    props: {formatMessage, history},
                    datacenter_name
                }) || {};
                let new_access: any = {},
                    url: any = <div className={'access-no-data'}><FormattedMessage id={'no_data'}/></div>;
                const list: any = data?.data || [];
                if (list && list[0] && list[0]?.externalPortalUrl?.length) {
                    url = (<div className={'access-col'}>{list[0].externalPortalUrl.map((val: string) => (
                        <Typography.Text
                            key={val}
                            copyable={{text: val}}
                            style={{display: 'block', overflowWrap: 'unset'}}
                        >
                            <u
                                title={val}
                                className={'access-rul'}
                                onClick={(e: React.MouseEvent) => {
                                    e.preventDefault();
                                    window.open(`https://${val}` || '', '_blank')
                                }}
                            >{val}</u>
                        </Typography.Text>
                    ))}</div>);
                }
                new_access[item?.serviceInstanceId] = url;
                new_access_list = {
                    ...new_access_list,
                    ...new_access
                };
                set_list_access_url(new_access_list);
            });

            new_apps_total?.map(async (item: any, key: any)=>{
                id_list.push(item?.serviceInstanceId);
                id_key.push(key);
                if(id_list.length>=2 || key>= new_apps_total.length-1){
                    const new_id = id_list, new_key = id_key;
                    id_list = [];
                    id_key = [];
                    const {data}: any = await worker_fetch({
                        url: `/appBuy/serviceInstances/${new_id.join(',')}/status`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    }) || {};
                    const status: any = data.data || [];
                    if (status.length) {
                        let new_status: any = {};
                        for (let j = 0; j < new_key.length; j++) {
                            const {currentVersion, canUpdate, actualStatus, allowVersionList, reason} = status[j] || {};
                            new_status[new_apps_total[new_key[j]].serviceInstanceId] = {
                                canUpdate,
                                currentVersion,
                                actualStatus,
                                allowVersionList,
                                reason
                            };
                        }
                        new_status_list = {
                            ...new_status_list,
                            ...new_status
                        };
                        set_list_status(new_status_list)
                    }
                }
            });
            refresh_status && clearInterval(refresh_status);
            set_refresh_status(setInterval(()=>{
                set_load_apps_total_version(true);
            }, 30000))
        }
        // eslint-disable-next-line
    }, [table_sorter_datasource, table_pagination, load_apps_total_version]);

    useEffect(() => {
        if (path.includes("applications")) {
            const subscription_session1 = new Cookies().get("subscription_id");
            if (user_info.ssoRole === "globalAdmin") {
                (async () => {
                    loading_alert_before();
                    await worker_fetch({
                        url: `/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`,
                        method: 0,
                        props: { formatMessage, history },
                        datacenter_name
                    });
                    const { data }: any = await worker_fetch({
                        url: `/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`,
                        method: 0,
                        props: { formatMessage, history },
                        datacenter_name
                    });
                    if (data?.resources) {
                        const { resources } = data;
                        const app_aubscription_new: user_subscription[] = [];
                        resources.map((item: any) => {
                            return app_aubscription_new.push({
                                subscriptionId: item.id,
                                subscriptionName: item.name,
                                company: item.company,
                                subscriptionRole: 'string',
                                clusterType: 'string',
                            })
                        });
                        const subscription_id: string | undefined = (
                            app_aubscription_new?.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === subscription_session1) ||
                            (app_aubscription_new || [])[0]
                        )?.subscriptionId;
                        set_user_subscriptions(app_aubscription_new);
                        cookies.set("subscription_id", subscription_id, get_domain());
                        set_user_info((currentState) => ({
                            ...currentState,
                            subscription_id,
                        }));
                    }
                    loading_alert_after();
                })()
            } else {
                if (user_info?.ssoSubscriptions && user_info?.ssoSubscriptions?.length > 0) {
                    const userSubscriptions_new1 = user_info?.ssoSubscriptions?.sort((a: user_subscription, b: user_subscription) =>
                        a.subscriptionName.toLocaleLowerCase().localeCompare(b.subscriptionName.toLocaleLowerCase())
                    ),
                        subscription_id: string | undefined = (
                            userSubscriptions_new1?.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === subscription_session1) ||
                            (userSubscriptions_new1 || [])[0]
                        )?.subscriptionId;
                    set_user_subscriptions(userSubscriptions_new1);
                    cookies.set("subscription_id", subscription_id, get_domain());
                    set_user_info((currentState) => ({
                        ...currentState,
                        subscription_id,
                    }));
                } else {
                    set_user_subscriptions([]);
                }
            }
        }
        // eslint-disable-next-line
    }, [path, user_info?.ssoSubscriptions])

    useEffect((): void => {
        set_select_menu(
            <Fragment>
                <Col sm={16}>
                    <Row>
                        <Col sm={6} className="px-6">
                            {/* <DropdownMenuSubscription /> */}
                            <div className={`font_size_14`}>
                                <FormattedMessage id="subscription_name" />
                            </div>
                            {user_subscriptions && <Select
                                className={`${!path.includes('console') && !path.includes('instance-list') ? 'height-40' : ''} w-100`}
                                showSearch
                                value={user_subscriptions.length > 0 ? user_info.subscription_id : ''}
                                // disabled={user_subscriptions.length < 2}
                                optionFilterProp="children"
                                dropdownRender={(menu) => (
                                    <Fragment>
                                        <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                                        {menu}
                                    </Fragment>
                                )}
                                filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
                                onChange={(event: string) => {
                                    const subscription_id_new: string | undefined = (
                                        user_subscriptions?.find(({ subscriptionId }: user_subscription) => subscriptionId === event) || (user_subscriptions || [])[0]
                                    )?.subscriptionId;
                                    
                                    if (subscription_id_new) {
                                        new Cookies().set("subscription_id", subscription_id_new, {
                                            domain: document.domain.substr(document.domain.indexOf(".")),
                                            path: "/",
                                        });
                                        set_user_info((currentState) => ({ ...currentState, role: "", subscription_id: subscription_id_new }));
                                    }

                                    set_cluster_selected({name: 'all'});
                                    set_workspace_selected({name: 'all'});
                                    set_namespace_selected({name: 'all'});
                                    set_clusters([]);
                                    set_workspaces(undefined);
                                    set_namespaces(undefined);
                                    sessionStorage.removeItem('cluster');
                                    sessionStorage.removeItem('workspace');
                                    sessionStorage.removeItem('namespace');
                                    set_load_apps_total(true);
                                    set_load_package_list(true);

                                }}
                            >
                                {Array.isArray(user_subscriptions) && user_subscriptions.length > 0 &&
                                    user_subscriptions.map(({ subscriptionId, subscriptionName, company }: user_subscription) => (
                                        <Option key={subscriptionName + company} value={subscriptionId}>
                                            <Row
                                                title={
                                                    formatMessage({ id: "subscription_name" }) +
                                                    ": " +
                                                    subscriptionName +
                                                    "        " +
                                                    formatMessage({ id: "company" }) +
                                                    ": " +
                                                    company
                                                }
                                            >
                                                <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                                    {subscriptionName}
                                                </Col>
                                                <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                                    {company}
                                                </Col>
                                            </Row>
                                        </Option>
                                    ))}
                            </Select>}
                        </Col>
                        <Col sm={6} className="px-6">
                            <Row>
                                <span title='cluster' className="font-14"><FormattedMessage id="cluster"/></span>
                                <Select
                                    disabled={(user_info?.ssoSubscriptions?.length === 0 && user_info.ssoRole !== "globalAdmin") ? true : false}
                                    size="large"
                                    style={{width: '100%', paddingLeft: 2}}
                                    showSearch
                                    optionFilterProp="children"
                                    className="font-bold-blue font-14"
                                    getPopupContainer={(node: any)=> node.parentNode}
                                    value={cluster_selected ? cluster_selected.name : roles.find((r: role_type) => r.cluster === sessionStorage.getItem('cluster'))?.cluster || 'all'}
                                    onChange={(event: string) => {
                                        set_cluster_selected((event === 'all')? {name: 'all'}: (clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event) || {}).metadata);
                                        set_workspaces(undefined);
                                        set_namespaces(undefined);
                                        set_workspace_selected({name: 'all'});
                                        set_namespace_selected({name: 'all'});
                                        sessionStorage.removeItem('workspace');
                                        sessionStorage.removeItem('namespace');
                                        sessionStorage.setItem('cluster', event);
                                        set_load_apps_total(true);
                                        set_load_package_list(true);
                                    }}
                                >
                                    <Option className={'font-bold-blue'} key={'all'} value={'all'}>
                                        <span className={'font-bold-blue'}>
                                            <FormattedMessage id={'all'}/>
                                        </span>
                                    </Option>
                                    {clusters?.length && Array.isArray(clusters) && clusters.map((cluster: clusters_type_item) =>
                                        <Option key={cluster.metadata.name} value={cluster.metadata.name}>{cluster.metadata.name}</Option>)
                                    }
                                </Select>
                            </Row>
                        </Col>
                        <Col sm={6} className="px-6">
                            <Row>
                                <span title="workspace" className="font-14" ><FormattedMessage id="workspace"/></span>
                                <Select
                                    disabled={(user_info?.ssoSubscriptions?.length === 0 && user_info.ssoRole !== "globalAdmin") ? true : false}
                                    size="large"
                                    showSearch
                                    optionFilterProp="children"
                                    value={workspace_selected?.labels ? workspace_selected.labels.name : 'all'}
                                    style={{width: '100%', paddingLeft: 2}}
                                    className="font-bold-blue font-14"
                                    getPopupContainer={(node: any)=> node.parentNode}
                                    onChange={(event: string) => {
                                        if(event === 'all') {
                                            set_workspace_selected({name: 'all'});
                                            set_namespace_selected({name: 'all'});
                                            sessionStorage.setItem("workspace", 'all');
                                            sessionStorage.removeItem('namespace');
                                        }else select(event, set_workspace_selected, true, workspaces);
                                        set_namespaces(undefined);
                                        set_load_apps_total(true);
                                        set_load_package_list(true);
                                        // set_namespace_selected({name: 'all'})
                                    }}
                                >
                                    <Option className={'font-bold-blue'} key={'all'} value={'all'}>
                                        <span className={'font-bold-blue'}>
                                            <FormattedMessage id={'all'}/>
                                        </span>
                                    </Option>
                                    {workspaces?.map((workspace: workspaces_type_item) =>
                                        <Option key={workspace?.metadata.uid} value={workspace?.metadata?.labels?.name}>{workspace?.metadata?.labels?.name}</Option>)
                                    }
                                </Select>
                            </Row>
                        </Col>
                        <Col sm={6} className="px-6">
                            <Row>
                                <span title="namespace" className="font-14"><FormattedMessage id="namespace"/></span>
                                <Select
                                    disabled={(user_info?.ssoSubscriptions?.length === 0 && user_info.ssoRole !== "globalAdmin") ? true : false}
                                    size="large"
                                    showSearch
                                    optionFilterProp="children"
                                    value={namespace_selected && namespace_selected.name ? namespace_selected.name : 'all'}
                                    style={{width: '100%', paddingLeft: 2}}
                                    className="font-bold-blue font-14"
                                    getPopupContainer={(node: any)=> node.parentNode}
                                    onChange={(event: string) => {
                                        if(event === 'all') {
                                            set_namespace_selected({name: 'all'});
                                            sessionStorage.setItem("namespaces", 'all');
                                        }else select(event, set_namespace_selected, false, namespaces);
                                        set_load_apps_total(true);
                                        set_load_package_list(true);
                                    }}
                                >
                                    <Option className={'blue'} key={'all'} value={'all'}>
                                        <span className={'font-bold-blue'}>
                                            <FormattedMessage id={'all'}/>
                                        </span>
                                    </Option>
                                    {namespaces && namespaces.map((namespace: namespaces_type_item) =>
                                        <Option key={namespace.metadata.uid} value={namespace.metadata.name}>{namespace.metadata.name}</Option>)
                                    }
                                </Select>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Fragment>)
            // eslint-disable-next-line
    }, [namespace_selected, namespaces, workspace_selected, workspaces, cluster_selected, clusters, set_cluster_selected, set_namespace_selected, set_workspace_selected, set_workspaces, set_namespaces, roles, formatMessage]);

    const data_columns: ColumnsType<object> = [
        {
            title: formatMessage({id: 'status'}),
            key: 'actualStatus',
            // align: 'center',
            render: ({serviceInstanceId}: any)=>{
                return list_status[serviceInstanceId]? {children: <div>
                        {/* <p className={`table-btn-status btn-status-bull ${return_color(list_status[serviceInstanceId]?.actualStatus || '')}`}>&bull;</p>
                        <p className={'btn-status-text'}>{list_status[serviceInstanceId]?.actualStatus}</p> */}
                        <span className={`text-left pr-6 ${return_color(list_status[serviceInstanceId]?.actualStatus || '')}`}>⬤</span>
                        <span className={'m-0 p-0 font-8'}>{list_status[serviceInstanceId]?.actualStatus}</span>
			            {list_status[serviceInstanceId]?.actualStatus === 'Unknown' && <Tooltip title={list_status[serviceInstanceId]?.reason}><QuestionCircleOutlined className={'btn-blue pointer pl-4'}/></Tooltip>}
                    </div>, props: {'data-title': 'Status'}}:
                    {children: <div>
                        {/* <p className={`table-btn-status btn-status-bull btn-default`}>&bull;</p>
                        <p className={'btn-status-text'}><FormattedMessage id={'loading'}/></p> */}
                        <span className={`text-left pr-6`}><SyncOutlined spin /></span>
                        <span className={'m-0 p-0 font-8'}><FormattedMessage id={'loading'}/></span>
                    </div>, props: {'data-title': 'Status'}}
            }
        },  {
            title: formatMessage({id: 'app_name'}),
            key: 'serviceName',
            sorter: (a: any, b: any) => {
                const str_a: string = a?.serviceName||'', str_b: string = b?.serviceName||'';
                return str_a.localeCompare(str_b);
            },
            render: ({lifecycleStatus, serviceInstanceName, serviceInstanceId, serviceName}: any)=>{
                return  serviceName? {
                    // children:  lifecycleStatus.toLowerCase() === 'active'?
                    //     <a href={'##'} style={{cursor: 'pointer', fontWeight: 'bold', textDecorationLine: 'underline'}} onClick={( e: React.MouseEvent<HTMLElement>)=> {
                    //         e.preventDefault();
                    //         sessionStorage.setItem('application_instance', JSON.stringify({
                    //             serviceInstanceName,
                    //             serviceInstanceId,
                    //             serviceName,
                    //             status: lifecycleStatus
                    //         }));
                    //         props.history.push('/applications-detail')
                    //     }}>{serviceName}</a>: <span style={{fontWeight: 'bold'}}>{serviceName}</span>,
                    children: <a href={'##'} style={{cursor: 'default', fontWeight: 'bold'}}>{serviceName}</a>,
                    props: {'data-title': 'Service Name'}
                }: {}
            }
        },{
            title: formatMessage({id: 'service_package'}),
            key: 'servicePackageName',
            sorter: (a: any, b: any) => {
                const str_a: string = a?.servicePackageName || '', str_b: string = b?.servicePackageName || '';
                return str_a.localeCompare(str_b);
            },
            render: (item: any)=>{
                return item? {children: item.servicePackageName || 'Unclassified', props: {'data-title': 'Plan'}}: {}
            }
        },  {
            title: formatMessage({id: 'cluster'}),
            key: 'clusterName',
            dataIndex: 'clusterName',
            sorter: (a: any, b: any) => {
                const str_a: string = a?.clusterName||'', str_b: string = b?.clusterName||'';
                return str_a.localeCompare(str_b);
            },
            render: (val: string)=>{
                const find_cluster = clusters && clusters.find((item: any)=> item?.metadata?.name === val);
                return val? {
                    children: (
                        <div>
                            {
                                find_cluster && find_cluster?.metadata.labels?.role && find_cluster?.metadata.labels?.role === "workspaceOwner" ? <span>{val}</span> : (
                                    <a href="##" onClick={(e: any) => {
                                        e.preventDefault();
                                        if (find_cluster) {
                                            sessionStorage.setItem('cluster', val); props.history.push('/cluster-info/overview')
                                        } else {
                                            alert('warning', formatMessage({ id: 'notification' }), formatMessage({ id: 'cluster_not_found' }))
                                        }
                                    }}>{val}</a>
                                )
                            }
                        </div>
                    ),
                    props: { 'data-title': 'Cluster' }
                } : {}
            }
        },{
            title: formatMessage({id: 'workspace'}),
            key: 'workspaceName',
            // dataIndex: 'workspaceName',
            sorter: (a: any, b: any) => {
                const str_a: string = a?.workspaceName||'', str_b: string = b?.workspaceName||'';
                return str_a.localeCompare(str_b);
            },
            render: ({clusterName, workspaceName, workspaceId})=>{return workspaceName? {children:  <a href="##" onClick={(e: any)=>{
                    e.preventDefault();
                    (async ()=>{
                        // const new_workspace: any = await worker_fetch({
                        //     url: `/v1/datacenter/${datacenter_name}/cluster/${clusterName}/workspacenames`,
                        //     method: 0,
                        //     props: {formatMessage, history},
                        //     datacenter_name
                        // });
                        // const items: any = new_workspace?.data?.items;
                        // if(items?.length>0){
                        //     const find_workspace = items.find((item: any)=> item?.name === workspaceName);
                        //     if(find_workspace) {
                        //         sessionStorage.setItem('cluster', clusterName);
                        //         sessionStorage.setItem('workspace', find_workspace?.id);
                        //         props.history.push('/workspace-info/overview')
                        //     } else {
                        //         alert('warning', formatMessage({id: 'notification'}), formatMessage({id: 'workspace_not_found'}))
                        //     }
                        // }else {
                        //     alert('warning', formatMessage({id: 'notification'}), formatMessage({id: 'workspace_not_found'}))
                        // }
                        const new_workspace: any = await worker_fetch({
                            url: `/v1/datacenter/${datacenter_name}/cluster/${clusterName}/workspace/${workspaceId}`,
                            method: 0,
                            props: {formatMessage, history},
                            datacenter_name
                        });
                        const items: any = new_workspace?.data;
                        if(items && items?.metadata){
                                sessionStorage.setItem('cluster', clusterName);
                                sessionStorage.setItem('workspace', items?.metadata?.name);
                                set_type_name(items?.metadata?.labels?.type === "general" ? "shared" : "dedicate")
                                props.history.push('/workspace-info/overview')
                        }else {
                            alert('warning', formatMessage({id: 'notification'}), formatMessage({id: 'workspace_not_found'}))
                        }
                    })();
                }}>{workspaceName}</a>, props: {'data-title': 'Workspace ID'}}: {}}
        },{
            title: formatMessage({id: 'namespace'}),
            key: 'namespaceName',
            // dataIndex: 'namespaceName',
            sorter: (a: any, b: any) => {
                const str_a: string = a?.namespaceName||'', str_b: string = b?.namespaceName||'';
                return str_a.localeCompare(str_b);
            },
            render: ({clusterName, workspaceId, namespaceName})=>{
                return namespaceName? {
                    children: <a href="##" onClick={(e: any)=>{
                        e.preventDefault();
                        (async ()=>{
                            const new_workspace: any = await worker_fetch({
                                url: `/v1/datacenter/${datacenter_name}/cluster/${clusterName}/workspace/${workspaceId}`,
                                method: 0,
                                props: {formatMessage, history},
                                datacenter_name
                            });
                            const wk_items: any = new_workspace?.data;
                            const new_namespace: any = await worker_fetch({
                                url: `/v1/datacenter/${datacenter_name}/cluster/${clusterName}/workspace/${workspaceId}/namespaces`,
                                method: 0,
                                props: {formatMessage, history},
                                datacenter_name
                            });
                            const items: any = new_namespace?.data?.items;
                            if(items?.length>0 && wk_items?.metadata){
                                set_type_name(wk_items?.metadata?.labels?.type === "general" ? "shared" : "dedicate");
                                const find_namespace = items.find((item: any)=> item?.metadata?.name === namespaceName);
                                if(find_namespace) {
                                    sessionStorage.setItem('cluster', clusterName);
                                    sessionStorage.setItem('workspace', workspaceId);
                                    sessionStorage.setItem('namespace', namespaceName);
                                    props.history.push('/namespace-info/overview')
                                } else {
                                    alert('warning', formatMessage({id: 'notification'}), formatMessage({id: 'namespace_not_found'}))
                                }
                            }else {
                                alert('warning', formatMessage({id: 'notification'}), formatMessage({id: 'namespace_not_found'}))
                            }
                        })();
                    }}>{namespaceName}</a>,
                    props: {'data-title': 'Namespace'}}: {}
            }
        },{
            title: formatMessage({id: 'Version'}),
            key: 'chartVersion',
            // sorter: (a: any, b: any) => {
            //     const str_a: string = a?.chartVersion || a?.appServiceInfo?.chartVersion||'', str_b: string = a?.chartVersion || b?.appServiceInfo?.chartVersion||'';
            //     return str_a.localeCompare(str_b);
            // },
            render: ({appServiceInfo, serviceInstanceId}: any)=>{
                const {currentVersion} = list_status[serviceInstanceId] || {currentVersion: ''};
                return (currentVersion || appServiceInfo?.chartVersion)? {
                    children: currentVersion || appServiceInfo?.chartVersion,
                    props: {'data-title': 'Service Instance ID'}}: {}
            }
        },{
            title: formatMessage({id: 'update'}),
            key: 'canUpdate',
            align: 'center',
            render: ({lifecycleStatus, serviceInstanceId}: any)=>{
                const {canUpdate} = list_status[serviceInstanceId] || {canUpdate: false, allowVersionList: []};
                const bool: boolean = (lifecycleStatus !== 'Inprogress' && canUpdate);
                return {
                    children: bool?
                        <Tooltip title={formatMessage({id: 'update'})}>
                            <UpdateIcon
                                className={'enable-action-icon'}
                                onClick={()=> {
                                    set_update_type(1);
                                    set_item_selected({serviceInstanceId});
                                    const default_version = list_status[serviceInstanceId]?.allowVersionList?.find((item: any)=> !!item.isBaseLine);
                                    set_update_version(default_version?.version || '');
                                    set_version_list(list_status[serviceInstanceId]?.allowVersionList);
                                    set_modal_data({
                                        title: 'update',
                                        visible: true,
                                        is_update: true,
                                        ok_btn: true,
                                        cancel_btn: true,
                                        confirm_content: <FormattedMessage id={'sure_update'}/>
                                    })
                                }}
                            />
                        </Tooltip>:
                        <Tooltip title={formatMessage({id: 'can_not_update'})}><UpdateIcon className={'disable-action-icon'} /></Tooltip>,
                    props: {'data-title': 'Update'}
                }
            }
        },{
            title: formatMessage({id: 'redeploy'}),
            key: 'canRedeploy',
            align: 'center',
            render: ({lifecycleStatus, serviceInstanceId}: any)=>{
                return {
                    children: lifecycleStatus !== 'Inprogress'?
                        <Tooltip title={formatMessage({id: 'redeploy'})}>
                            <CloudUploadOutlined
                                className={'enable-action-icon'}
                                onClick={()=> {
                                    set_item_selected({serviceInstanceId});
                                    set_modal_data({
                                        title: 'redeploy',
                                        visible: true,
                                        cancel_btn: true,
                                        ok_btn: true,
                                        is_confirm: true,
                                        confirm_content: <FormattedMessage id={'sure_redeploy'}/>
                                    })
                                }}
                            />
                        </Tooltip>:
                        <CloudUploadOutlined className={'disable-action-icon'} />,
                    props: {'data-title': 'Redeploy'}
                }
            }
        },{
            title: `${formatMessage({id: 'start'})}/${formatMessage({id: 'stop'})}`,
            key: 'canStartStop',
            align: 'center',
            render: ({serviceInstanceId, lifecycleStatus}: any)=>{
                const {actualStatus} = list_status[serviceInstanceId] || {actualStatus: ''};
                return {
                    children: lifecycleStatus !== 'Inprogress'? actualStatus === 'Stopped'?
                        <Tooltip title={formatMessage({id: 'start_app'})}>
                            <PlayCircleFilled
                                className={'enable-action-icon'}
                                onClick={()=> {
                                    set_item_selected({serviceInstanceId});
                                    set_modal_data({
                                        title: 'start',
                                        visible: true,
                                        cancel_btn: true,
                                        ok_btn: true,
                                        is_confirm: true,
                                        confirm_content: <FormattedMessage id={`sure_start`}/>
                                    })
                                }}
                            />
                        </Tooltip>:
                        <Tooltip title={formatMessage({id: 'stop_app'})}>
                            <StopIcon
                                className={'enable-action-icon'}
                                onClick={()=> {
                                    set_item_selected({serviceInstanceId});
                                    set_modal_data({
                                        title: 'stop',
                                        visible: true,
                                        cancel_btn: true,
                                        ok_btn: true,
                                        is_confirm: true,
                                        confirm_content: <FormattedMessage id={`sure_stop`}/>
                                    })
                                }}
                            />
                        </Tooltip>:
                        <StopIcon className={'disable-action-icon'} />,
                    props: {'data-title': 'Start/Stop'}
                }
            }
        },{
            title: formatMessage({id: 'access_url'}),
            key: 'accessUrl',
            align: 'center',
            render: ({serviceInstanceId, lifecycleStatus}: any)=>{
                return list_access_url[serviceInstanceId]?{
                    children: lifecycleStatus !== 'Inprogress'?
                        <Popover content={list_access_url[serviceInstanceId] || <div className={'access-no-data'}><FormattedMessage id={'loading'}/></div>}>
                            <LinkOutlined className={'enable-action-icon'} />
                        </Popover>: <LinkOutlined className={'disable-action-icon'} />,
                    props: {'data-title': 'Access URL'}
                }:{}
            }
        },{
            title: formatMessage({ id: "web_kubectl" }),
            key: 'web_kubectl',
            align: 'center',
            render: ({clusterName, namespaceName})=>{
                return clusterName && namespaceName ? {
                    children: (
                        <Tooltip title={formatMessage({ id: "web_kubectl" })}>
                            <span
                                className={'enable-action-icon'}
                                onClick={(e: any) => {
                                    e.stopPropagation();
                                    set_table_list_modal((currentState) => ({
                                        ...currentState,
                                        visible: true,
                                        modal_title: formatMessage({ id: "web_kubectl" }),
                                        is_web_kubectl: true,
                                        kubectl_app_cluster: clusterName,
                                        kubectl_app_namespace: namespaceName,
                                    }));
                                }}
                            >
                                <img src={terminal} alt="web kubectl" style={{height: '16px'}} />
                            </span>
                        </Tooltip>
                        
                    ),
                    props: {'data-title': 'Web kubectl'}
                }:{}
            }
        }
    ];

    const on_btn_click = async ()=>{
        set_modal_loading(true);
        const {serviceInstanceId} = item_selected;
        if (modal_data?.is_confirm || modal_data?.is_update) {
            const instance: any = await worker_fetch({
                url: `/appBuy/serviceInstances/${serviceInstanceId}/instances`,
                method: 0,
                props: {formatMessage, history},
                datacenter_name
            });
            const {data} = instance.data;
            if (data?.[0]) {
                switch (modal_data?.title) {
                    case 'redeploy':
                        const redeploy: any = await worker_fetch({
                            url: `/appBuy/serviceInstances/${data?.[0].appServiceInstanceId}/redeploy`,
                            method: 2,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (redeploy.status === 201) {
                            set_load_apps_total(true);
                            set_load_package_list(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'redeploy_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${redeploy.status}: ${redeploy.data.error}`)
                        }
                        break;
                    case 'start':
                        const start: any = await worker_fetch({
                            url: `/appBuy/subscriptions/${data?.[0].id}/resume`,
                            method: 4,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (start.status === 201) {
                            set_load_apps_total(true);
                            set_load_package_list(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'start_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${start.status}: ${start.data.error}`)
                        }
                        break;
                    case 'stop':
                        const stop: any = await worker_fetch({
                            url: `/appBuy/subscriptions/${data?.[0].id}/limit`,
                            method: 4,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (stop.status === 201) {
                            set_load_apps_total(true);
                            set_load_package_list(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'stop_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${stop.status}: ${stop.data.error}`)
                        }
                        break;
                    case 'update':
                        if(update_version) {
                            const update: any = await worker_fetch({
                                url: `/appBuy/serviceInstances/${data?.[0].appServiceInstanceId}/update?version=${update_version}`,
                                method: 2,
                                props: {formatMessage, history},
                                datacenter_name,
                                warning: false
                            });
                            if (update.status === 201) {
                                set_load_apps_total(true);
                                set_load_package_list(true);
                                set_modal_data({visible: false});
                                alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'update_success'}))
                            } else {
                                set_modal_data({visible: false});
                                alert('error', formatMessage({id: modal_data.title}), `${update.status}: ${update.data.error}`)
                            }
                        }else {
                            notification.error({
                                message: formatMessage({id: 'error'}),
                                description: 'Version is required.'
                            })
                        }
                        break;
                    default:
                        break;
                }
            }else {

            }
            set_modal_loading(false);
        }
    };

    useEffect(()=>{
        if(apps_total.length > 0) {
            if (package_selected && package_selected !== 'all') {
                const new_selected: string = (package_selected==='unclassified'? '': package_selected);
                const lite: app_item[] = apps_total.filter((item: app_item) => item.servicePackageName === new_selected);
                set_table_sorter_datasource(lite);
                set_datasource(lite);
            } else {
                set_table_sorter_datasource(apps_total);
                set_datasource(apps_total);
            }
        }else {
            set_datasource([]);
        }
    }, [apps_total, package_selected]);

    useEffect(()=>{
        set_table_ele(<Table
            size="small"
            // title={()=> <Row>
            //     <span className='app-table-label'><FormattedMessage id="service_package"/></span>
            //     <Col span={6} className="px-6">
            //         <Select
            //             showSearch
            //             optionFilterProp="children"
            //             value={package_selected || 'all'}
            //             style={{width: '100%', paddingLeft: 2}}
            //             className={'font-bold-blue'}
            //             getPopupContainer={(node: any)=> node.parentNode}
            //             onChange={(event: string) => {
            //                 event !== 'all' && set_search_value('');
            //                 set_package_selected(event);
            //                 sessionStorage.setItem("package_selected", event);
            //             }}
            //         >
            //             <Option key={'all'} value={'all'}>
            //                 <span className={'font-bold-blue'}>
            //                     <FormattedMessage id={'all'}/>
            //                 </span>
            //             </Option>
            //             {package_list?.map((item: string) => <Option
            //                 key={item}
            //                 title={item}
            //                 value={item}
            //             >{item}</Option>)}
            //             {apps_total?.length > 0 && <Option key={'unclassified'} value={'unclassified'}><FormattedMessage
            //                 id={'unclassified'}/></Option>}
            //         </Select>
            //     </Col>
            // </Row>}
            rowKey={({serviceInstanceId}: any)=> serviceInstanceId}
            columns={data_columns}
            dataSource={datasource.length ?
                (search_value !== '' ?
                        datasource.filter((item: app_item) => item.serviceName.toLocaleLowerCase().indexOf(search_value.toLocaleLowerCase()) > -1) :
                        datasource
                ) : []}
            showSorterTooltip={false}
            pagination={{defaultPageSize: 10}}
            onChange={(pagination: any, filter: any, sorter: any, extra: any)=>{
                set_table_pagination(pagination);
                set_table_sorter_datasource(extra?.currentDataSource || []);
                set_load_apps_total_version(true);
            }}
        />)
        // eslint-disable-next-line
    }, [datasource, list_status, list_access_url, search_value, intl.messages, package_selected, apps_total]);

    return (
        <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
            <Col className="px-20 mt-20 new_application">
                <TableListModal />
                <Row>
                    <Col sm={24}>
                        <Row className="">
                            <Col sm={24}>
                                <Row align="middle">
                                    <Col sm={24}>
                                        <div className="card_title management-label-line font-size-16">
                                            <FormattedMessage id="applications" />
                                            <Tooltip placement="rightBottom" title={<FormattedMessage
                                            id="applications_desc" />}><QuestionCircleOutlined className="autoscale_help" /></Tooltip>
                                            &nbsp;({location_total})
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="management-select-area w-100">
                                    <Fragment>{select_menu}</Fragment>
                                    <Col sm={8} className="px-6">
                                        <span className='font-w-6 text-center'>&nbsp;</span>
                                        <Input
                                            style={{height: '40px', marginTop: '-2px'}}
                                            value={search_value}
                                            className="box_rounded input_no_border"
                                            size="large"
                                            allowClear
                                            prefix={<SearchOutlined className={'font-bold-blue'} />}
                                            placeholder={`${formatMessage({ id: 'please_input_ ' })}${formatMessage({ id: 'app_name' })}`}
                                            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                                                if (event.keyCode === 13) event.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                set_search_value(e.target.value)
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className={'mt-20 management-table w-100'}>
                        <div className="pb-5 w-100 bg-white d-flex">
                                <span className='app-table-label px-6'><FormattedMessage id="service_package"/></span>
                                <span className="px-6 min-width-220">
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        value={package_selected || 'all'}
                                        style={{width: '100%', paddingLeft: 2}}
                                        className={'font-bold-blue'}
                                        getPopupContainer={(node: any)=> node.parentNode}
                                        onChange={(event: string) => {
                                            event !== 'all' && set_search_value('');
                                            set_package_selected(event);
                                            sessionStorage.setItem("package_selected", event);
                                        }}
                                    >
                                        <Option key={'all'} value={'all'}>
                                            <span className={'font-bold-blue'}>
                                                <FormattedMessage id={'all'}/>
                                            </span>
                                        </Option>
                                        {package_list?.map((item: string) => <Option
                                            key={item}
                                            title={item}
                                            value={item}
                                        >{item}</Option>)}
                                        {apps_total?.length > 0 && <Option key={'unclassified'} value={'unclassified'}><FormattedMessage
                                            id={'unclassified'}/></Option>}
                                    </Select>
                                </span>
                            </div>
                            <Col span={24} className="no_pointer">{table_ele}</Col>
                        </Row>
                    </Col>
                </Row>
                <Modal
                    visible={modal_data?.visible}
                    title={formatMessage({ id: modal_data?.title || 'title' })}
                    maskClosable={true}
                    onCancel={() => set_modal_data({ visible: false })}
                    onOk={on_btn_click}
                    width={500}
                    footer={<div>
                        {modal_data?.cancel_btn &&
                            <Button onClick={() => set_modal_data({ visible: false })}><FormattedMessage
                                id={'cancel'} /></Button>}
                        {modal_data?.ok_btn && modal_loading ?
                            <Button type='default' disabled><LoadingOutlined /></Button> :
                            <Button
                                type='primary'
                                onClick={on_btn_click}
                            ><FormattedMessage id={'ok'} /></Button>
                        }
                    </div>}
                >
                    {modal_data?.is_confirm && <Row>
                        <Col span={24}>
                            <span>{modal_data.confirm_content}</span>
                        </Col>
                    </Row>}
                    {modal_data?.is_update && <Row>
                        <Col span={24} className={'pb-10'}>
                            <FormattedMessage id={'version'}/>: &nbsp;&nbsp;
                            <Radio.Group
                                onChange={(val: any)=>{
                                    set_update_type(val?.target?.value || 1);
                                    const new_version = version_list?.find((item: any)=> val?.target?.value === 1? !!item.isBaseLine: !item.isBaseLine);
                                    set_update_version(new_version?.version || '');
                                }}
                                value={update_type}
                            >
                                <Radio value={1}>Baseline</Radio>
                                <Radio value={2}>Non-Baseline</Radio>
                            </Radio.Group>
                        </Col>
                        <Col span={24} className="mt-10">
                            <Select
                                style={{width: '100%'}}
                                value={update_version}
                                onChange={(e: string) => set_update_version(e)}
                            >{version_list?.map(({version, isBaseLine}: any) => (
                                (update_type === 1 ? isBaseLine: !isBaseLine) &&<Select.Option
                                    key={version}
                                    value={version}
                                >{version}</Select.Option>
                            ))}</Select>
                        </Col>
                    </Row>}
                </Modal>
            </Col>
            <Modal
                visible={subscription_noapp_modal_visible}
                width={780}
                footer={null}
                centered={true}
                onCancel={() => set_subscription_noapp_modal_visible(false)}
                className="norole_modal"
            >
                <div className="no_role_div">
                    <img src={cry} alt="sorry" />
                    <span className="px-20"><FormattedMessage id="sorry_no_app_permission" /></span>
                </div>
            </Modal>
        </TableListModalContext.Provider>
    )
};

export default withRouter(injectIntl(Applications) as any);
